module.exports = __webpack_public_path__ + "img/video_blue.2b887b35.png";